import dynamic from 'next/dynamic';

const DynamicImageCropper = dynamic(() => import('./DeviceImageCropper'));

export default DynamicImageCropper;
